/**
 * Insere funcionalidades adicionais nos objetos Button
 *
 * @author Wellington
 * @since 2025-05-22
 * @version 1.0.0
 * @license Comercial
 */

const htmlTableRowElementExtensions = {
  /**
   * 
   */
  addCell(options) {
    const tag = this.parentElement.tagName === 'THEAD' ? 'th' : 'td';
    const cell = document.createElement(tag);

    if (!options) {
      options = {};
    }

    if (typeof options?.colspan === 'number') {
      cell.colSpan = options.colspan;
    }

    if (typeof options?.rowspan === 'number') {
      cell.rowSpan = options.rowspan;
    }

    if (tag === 'th') {
      if (options?.sortable) {
        const key = options.alias || options.id.split('.').pop();
        if (key) {
          cell.dataset.key = key;
        }

        cell.dataset.sortable = true;
        cell.classList.add('dg-sort');
      }

    }

    if (options?.class) {
      options.class.split(/\s+/).map(className => {
        cell.classList.add(className);
      });
    }

    if (options?.mask?.template) {
      cell.classList.add(`dg-${options.mask.template}`);
    }

    if (options?.style) {
      for (const key in options.style) {
        cell.style[key] = options.style[key];
      }
    }

    cell.addContent(options);

    this.appendChild(cell);
    return cell;
  }
};

/**
 * Adiciona os métodos ao protótipo de HTMLTableRowElement
 */
const extendHTMLTableRowElement = () => {
  Object.entries(htmlTableRowElementExtensions).forEach(([key, value]) => {
    if (!HTMLTableRowElement.prototype[key]) {
      HTMLTableRowElement.prototype[key] = value;
    } else {
      console.warn(`HTMLTableRowElement.prototype.${key} já existe e não será sobrescrito.`);
    }
  });
};

export default extendHTMLTableRowElement;
